<div class="warp-tooltip" *ngIf="name">
  <div class="auto-fill-field-name">
    <img src="/assets/images/question-menu/table-field.svg" />
    <span>{{ name }}</span>
  </div>
  <div class="tooltip-abs">
    <p translate>tableField.selectedFieldTooltip</p>
  </div>
</div>
